import MenuGroup from "aldoo-ra/MenuGroup"
import SiteLanguageSelector from "../SiteLanguageSelector/button"
import PubSub from "pubsub-js"
import HamburgerMenu from "./hamburgerMenu"

const HeaderMenuMobile = () => {
  return (
    <div className="flex w-full bg-navbar flex-row h-header_height  items-center justify-between shadow-[0_0_20px_0_rgba(0,0,0,0.06)]">
      {/* Main Menu Container */}
      <div className="xl:max-w-w2_xl h-header_height flex flex-row w-full items-center justify-between gap-[20px] px-4 mx-auto">
        <HamburgerMenu />

        {/* Logo */}
        <div className="absolute left-1/2 transform -translate-x-1/2 w-[118px] md:w-[140px] h-auto flex-shrink-0">
          <MenuGroup
            name="Header Logo"
            renderAs="hlist.icons"
            iconRecolor={false}
            styleOverrides={{
              menu: "py-0 my-0",
              menu_item: "py-0 my-0",
            }}
          />
        </div>

        {/* Language and Account Group */}
        <div className="h-header_height flex items-center justify-center flex-shrink-0">
          {/* Hide Languages for Phase 2 ---------------------*/}
          <SiteLanguageSelector />

          {/* <div className="hidden md:block border-r border-bordered h-[40px] mr-4" /> */}

          {/* Profile Icon (div dimensions give us desired icon dims) */}
          {/* <div className="w-[44px] md:w-[50px] aspect-1/1 px-[10px] flex items-center justify-center">
            <MenuGroup
              name="Header Profile"
              renderAs="hlist.icons"
              actionMap={{
                signin: () =>
                  PubSub.publish("signin", {
                    redirect: "/account",
                  }),
              }}
            />
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default HeaderMenuMobile
